<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>系统设置</el-breadcrumb-item>
        <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="operating">
      <span> <el-button type="primary" size="small" @click="addOpen" >添加菜单</el-button></span>
    </div>
    <div>
      <template>
        <el-tree
          :data="menuTree"
          node-key="id"
          default-expand-all
          :props="{label: 'name', children: 'child',value: 'id'}"
          :expand-on-click-node="false">
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <el-row :gutter="20">
          <el-col :span="6"><div class="grid-content-menu">
            <span><i :class="data.parent_id === 0?data.icon: ''"></i>{{ node.label }}</span>
          </div></el-col>

          <el-col :span="6"><div class="grid-content-menu">
             <span >权重: {{data.weight}}</span>
          </div></el-col>
          <el-col :span="6"><div class="grid-content-menu">
            <span v-if="!('child' in data)">路由: {{data.route}}</span>
          </div></el-col>
        </el-row>
        <span>
          <el-button
            type="text"
            size="mini"
            @click="() => editOpen(data)">
            编辑
          </el-button>
          <el-popconfirm
            title="确定删除吗？"
            @onConfirm="remove(data)"
          >
            <el-button
              slot="reference"
              type="text"
              size="mini"
            >删除</el-button>
          </el-popconfirm>
        </span>
      </span>
        </el-tree>
      </template>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @open="openDialog" @close="close" :close-on-click-modal="false"  width="600px" class="padding_10">
      <el-form :model="storeForm" label-width="120px" :rules="rules" ref="storeForm">
        <el-form-item label="菜单名称" prop="name">
          <el-input v-model="storeForm.name" auto-complete="off" placeholder="请输入菜单名称"></el-input>
        </el-form-item>
        <el-form-item label="父级菜单" prop="parent_id">
          <el-cascader
            style="width: 100%"
            v-model="storeForm.parent_id"
            :options="menuTree"
            :props="{label: 'name', children: 'child',value: 'id', checkStrictly: true, emitPath: false}"
            clearable>
          </el-cascader>
        </el-form-item>
        <el-form-item label="菜单icon" prop="icon" :rules="storeForm.parent_id === 0 ? [{ required: true, message: '请输入菜单icon', trigger: 'blur' }] : []">
          <el-input v-model.number="storeForm.icon" auto-complete="off"  placeholder="请输入菜单icon"></el-input>
        </el-form-item>
        <el-form-item label="菜单权重" prop="weight">
          <el-input v-model.number="storeForm.weight" auto-complete="off" placeholder="请输入菜单权重 倒序"></el-input>
        </el-form-item>
        <el-form-item label="菜单路由" prop="route">
          <el-input v-model.number="storeForm.route" auto-complete="off" placeholder="请输入菜单路由"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="store">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style>
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .grid-content-menu {
    border-radius: 4px;
    min-width: 140px;
  }
</style>

<script>
import {addMenu, deleteMenu, menuAll, updateMenu} from '../../api/auth'

export default {
  data () {
    return {
      menuTree: [],
      dialogTitle: '',
      dialogVisible: false,
      loading: false,
      storeForm: {
        id: 0,
        name: '',
        weight: '',
        icon: '',
        parent_id: '',
        route: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' }
        ],
        weight: [
          { required: true, message: '请输入菜单权重', trigger: 'blur' }
        ]
      },
      itemForm: {
        id: 0,
        name: '',
        weight: '',
        icon: '',
        parent_id: '',
        route: ''
      }
    }
  },
  mounted () {
    this.getMenuList()
  },
  methods: {
    // 获取所有菜单
    getMenuList () {
      menuAll().then(res => {
        let {status} = res
        if (status === 2000) {
          this.menuTree = res.data
        } else {
          this.menuTree = []
        }
      })
    },
    // 打开弹窗
    addOpen () {
      this.itemForm = {
        id: 0,
        name: '',
        weight: '',
        icon: '',
        parent_id: '',
        route: ''
      }
      this.dialogVisible = true
      this.dialogTitle = '添加菜单'
    },
    // 打开弹窗回调
    openDialog () {
      this.storeForm = this.itemForm
    },
    // 关闭弹窗回调
    close () {
      this.dialogTitle = ''
      this.$refs['storeForm'].resetFields()
    },
    // 提交表单
    store () {
      this.loading = true
      this.$refs['storeForm'].validate(async (valid) => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.storeForm))
          let res = {}
          if (this.storeForm.id === 0) {
            res = await addMenu(data)
          } else {
            res = await updateMenu(data)
          }
          let {status, message} = res
          if (status === 2000) {
            this.dialogVisible = false
            this.getMenuList()
          }
          this.$notify({
            message: message,
            type: status === 2000 ? 'success' : 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 删除
    remove (data) {
      deleteMenu({id: data.id}).then(res => {
        if (res.status === 2000) {
          this.getMenuList()
        }
        this.$notify({
          message: res.message,
          type: res.status === 2000 ? 'success' : 'warning',
          offset: 100,
          showClose: false
        })
      })
    },
    // 编辑打开
    editOpen (data) {
      this.itemForm = {
        id: data.id,
        name: data.name,
        weight: data.weight,
        icon: data.icon,
        parent_id: data.parent_id,
        route: data.route
      }
      this.dialogVisible = true
      this.dialogTitle = '编辑菜单'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/menu/index.vue